import { gql, useMutation } from '@apollo/client';

const UPLOAD_COMPANY_LOGO = gql`
  mutation uploadCompanyLogoById($logo: Upload, $companyId: ObjectId!) {
    uploadCompanyLogoById(logo: $logo, companyId: $companyId) {
      _id
      logoUrl
    }
  }
`;

export const useUploadCompanyLogoById = () => {
  const [uploadCompanyLogoById] = useMutation(UPLOAD_COMPANY_LOGO);

  return uploadCompanyLogoById;
};
